import { useTranslation } from 'react-i18next';

import useRemoteBoundStore from 'src/store/useRemoteBoundStore';

import { Eye, EyeToShootingType } from 'src/models/Eye.model';
import { I18NextNS } from 'src/models/Language.model';

import { useGetCurrentCaptureProcess } from 'src/hooks/camera/useGetCurrentCaptureProcess';

interface IImageStatusTextProps {
  imageUrl: string;
  isUploadMode?: boolean;
  eyeType?: Eye;
  hasCanceled?: boolean;
}

const ImageStatusText = ({
  imageUrl,
  isUploadMode = false,
  eyeType,
  hasCanceled = false,
}: IImageStatusTextProps) => {
  const { t } = useTranslation(I18NextNS.PAGES);

  const { isCanceling } = useRemoteBoundStore();

  const { currentCaptureProcess } = useGetCurrentCaptureProcess();

  if (
    isCanceling &&
    eyeType &&
    currentCaptureProcess?.take === EyeToShootingType[eyeType]
  ) {
    return (
      <>
        <strong>{t('newExam.imageStatus.cancelingImaging')}</strong>
      </>
    );
  }

  if (hasCanceled && !imageUrl) {
    return (
      <>
        <strong>{t('newExam.imageStatus.canceled')}</strong>
        <br />
        {t('newExam.imageStatus.canceledDesc')}
      </>
    );
  }

  if (!imageUrl) {
    return isUploadMode ? (
      <>
        <strong>{t('newExam.imageStatus.noImageUploaded')}</strong>
        <br />
        {t('newExam.imageStatus.noImageUploadedDesc')}
      </>
    ) : (
      <>
        <strong>{t('newExam.imageStatus.captureInProgress')}</strong>
        <br />
        {t('newExam.imageStatus.captureInProgressDesc')}
      </>
    );
  }

  return isUploadMode ? (
    <>
      <strong>{t('newExam.imageStatus.uploadedSuccessfully')}</strong>
      <br />
      {t('newExam.imageStatus.uploadedSuccessfullyDesc')}
    </>
  ) : (
    <>
      <strong>{t('newExam.imageStatus.capturedSuccessfully')}</strong>
      <br />
      {t('newExam.imageStatus.capturedSuccessfullyDesc')}
    </>
  );
};

export default ImageStatusText;
